import { FC, PropsWithChildren } from "react";
import cn from "classnames";

interface Props {
    classNames: string;
    autoHeight?: boolean;
}

const ModalContent: FC<PropsWithChildren & Props> = ({ children, classNames, autoHeight = false }) => {
    return (
        <div
            onClick={(e) => e.stopPropagation()}
            className={cn(
                "card md:w-96 gap-3 backdrop-blur-3xl border border-muted-foreground bg-card-solid  w-full h-[90svh] md:h-max-[50svh] bottom-0 md:bottom-1/2 md:translate-y-1/2 absolute rounded-b-none md:rounded-b-2xl flex flex-col",
                autoHeight ? "h-fit" : "md:h-max-[50svh] h-fit",
                classNames,
            )}
        >
            {children}
        </div>
    );
};

export default ModalContent;
